export const Authendpoint = {
  Login: "/admin/auth/login",
  SignUp: "/admin/register",
};
